<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-dimension`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 5a8 8 0 012 15.748v4.143l6.838 4.276a8 8 0 11-2.83 2.945l-6.009-3.755-6.006 3.754a8 8 0 11-2.83-2.945L22 24.893v-4.144A8 8 0 0124 5zM11 32a4 4 0 100 8 4 4 0 000-8zm26 0a4 4 0 100 8 4 4 0 000-8zM24 9a4 4 0 100 8 4 4 0 000-8z"/></svg>
</template>
<script>

export default {
  name: 'IconDimension',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
